var map = {
	"./border-bg-sm.png": 1392,
	"./border-bg.png": 1393,
	"./btn-active.png": 1394,
	"./cny-flower-1.webp": 1395,
	"./cny-flower-2.webp": 1396,
	"./cny-mobile-bg.webp": 1397,
	"./content-deco-1.webp": 1398,
	"./content-deco-2.webp": 1399,
	"./content-deco-3.webp": 1400,
	"./content-deco-4.webp": 1401,
	"./content-deco-5.webp": 1402,
	"./deposit-icon.webp": 1403,
	"./home-icon-active.webp": 1404,
	"./home-icon.webp": 1405,
	"./live-icon-active.webp": 1406,
	"./live-icon.webp": 1407,
	"./master-bg.png": 1408,
	"./me-icon-active.webp": 1409,
	"./me-icon.webp": 1410,
	"./platform.webp": 1411,
	"./product-overview-bg.webp": 1412,
	"./promos-icon-active.webp": 1413,
	"./promos-icon.webp": 1414,
	"./sponsor-icon-active.webp": 1415,
	"./sponsor-icon.webp": 1416,
	"./title-deco-bg.webp": 1417,
	"./title-deco-left.webp": 1418,
	"./title-deco-right.webp": 1419,
	"./vip-icon-active.webp": 1420,
	"./vip-icon.webp": 1421,
	"./withdraw-icon.webp": 1422,
	"./wwr-bg.webp": 1423,
	"./wwr-img.webp": 1424
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 131;